(function () {
    var swiperInitialized = false;
  
    function initSwiper() {
      if (swiperInitialized) return;
  
      const $currentSwiper = document.querySelector(".media-mentions");
      if (!$currentSwiper) return;
  
      const enableSwiperDesktop =
        $currentSwiper.dataset.enableSwiperDesktop === "true";
      const enableSwiperMobile =
        $currentSwiper.dataset.enableSwiperMobile === "true";
      const totalSlides =
        $currentSwiper.querySelectorAll(".swiper-slide").length;
      const desktopRotationSpeed =
        parseInt($currentSwiper.dataset.desktopRotationSpeed) || 7000;
      const mobileRotationSpeed =
        parseInt($currentSwiper.dataset.mobileRotationSpeed) || 7000;
      const transitionSmoothness =
        parseInt($currentSwiper.dataset.transitionSmoothness) || 750;
  
      function initSlider() {
        const containerWidth = window.innerWidth;
  
        if (containerWidth >= 768 && enableSwiperDesktop) {
          if (window.swiperFull) {
            window.swiperFull.destroy();
          }
  
          window.swiperFull = new Swiper(".media-mentions", {
            slidesPerView: "auto",
            spaceBetween: 30,
            loop: totalSlides > 4,
            speed: totalSlides > 4 ? desktopRotationSpeed : transitionSmoothness,
            autoplay: totalSlides > 4 ? { delay: 0 } : false,
            allowTouchMove: true,
            grabCursor: true,
            on: {
              touchStart: (swiper) => {
                swiper.autoplay.stop();
              },
              touchEnd: (swiper) => {
                setTimeout(() => {
                  swiper.autoplay.start();
                }, 3000);
              },
            },
          });
        } else if (containerWidth < 768 && enableSwiperMobile) {
          if (window.swiperMobile) {
            window.swiperMobile.destroy();
          }
  
          window.swiperMobile = new Swiper(".media-mentions", {
            slidesPerView: 1,
            spaceBetween: 15,
            loop: true,
            speed: 300,
            autoplay: totalSlides > 1 ? { delay: mobileRotationSpeed, disableOnInteraction: false } : false,
            allowTouchMove: true,
            pagination: {
              el: ".swiper-pagination.mentions-pagination",
              clickable: true,
            },
            on: {
              touchStart: (swiper) => {
                swiper.autoplay.stop();
              },
              touchEnd: (swiper) => {
                setTimeout(() => {
                  swiper.autoplay.start();
                }, 3000);
              },
            },
          });
        }
      }
  
      function handleResize() {
        initSlider();
      }
  
      initSlider();
      window.addEventListener("resize", handleResize);
  
      swiperInitialized = true;
    }
  
    var observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        initSwiper();
        observer.disconnect();
      }
    });
  
    observer.observe(document.querySelector(".slider-home"));
  })();